<!--
  (c) Copyright 2024 Calabrio, Inc.
  All Rights Reserved. www.calabrio.com LICENSED MATERIALS
  Property of Calabrio, Inc., Minnesota, USA

  No part of this publication may be reproduced, stored or transmitted,
  in any form or by any means (electronic, mechanical, photocopying,
  recording or otherwise) without prior written permission from Calabrio, Inc.
-->

<template>
  <div class="wy-performance-overview-panel-top-intents"   @mouseover="mouseover" @mouseout="mouseout">
    <wy-panel-header ref="panelHeader" v-if="tableData" :panelHeaderData="tableData" :controller="module" :panelTitle="panelTitle" />
    <div v-loading="loading"  class="table-container">
      <table v-if="tableData && tableData.data && tableData.data.length>0" class="performance-overview-table" element-loading-text="Loading..." >
        <thead>
          <tr class="table-titles">
            <div class="table-flex-container head-container">
              <td class="performance-table-head table-head intent-name">Intent Name</td>
              <td class="index"></td>
              <td class="performance-table-head table-head volume">Volume</td>
              <td class="performance-table-head table-head total-volume total-valume-header">%Total Volume</td>
            </div>
          </tr>
        </thead>
        <tbody>
        <tr v-for="(item, index) in tableData.data" :key="index">
          <div class="table-flex-container">
            <td :title="item.intentName" class="intent-name">
              <span class="index">{{index + 1}}</span>
              <span class="intent">{{item.intentName}}</span></td>
            <td class="index"></td>
            <td class="volume">{{item.volume.toLocaleString('en-US')}}</td>
            <td class="total-volume">
              <div class="flex-stats">
                <span class="percentage">{{Number(item.totalVolume).toFixed(2)}}%</span>
              </div>
            </td>
          </div>
        </tr>
        </tbody>
      </table>
      <div v-else class="no-data-flex"> 
      <img class="no-data-image" src="../../../assets/icons/icon_performance_no_data.svg" alt="no data icon">
      <span class="no-data-text">Sorry!</span>
      <span class="no-data-text-small">No data available yet.</span>
    </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapGetters, mapActions } from 'vuex';
import WyPerformanceUtils from '../utils/wy-performance-utils.js';
import WyPanelHeader from '../../panel-views/wy-panel-header.vue';

export default Vue.extend({
  name: 'wy-performance-overview-panel-top-intents',
  props: ["controller", "panelTitle"],
  components: { 
    'wy-panel-header': WyPanelHeader
  },
  computed: {
    ...mapGetters(['dataModel', 'isLoggedIn', 'config']),
  },
  data() {
    return {
      module: this,
      loading: false,
      tableData: {},
      panelId: 'intentTable',
    }
  },

  methods: {
    ...mapActions(['fetchIntentToContainConversationChartData', 'preparePerformanceViewByData', 'fetchIntentToIntents']),

    mouseover() {
      // this.$refs.panelHeader.$refs.settingSection.$el.classList.add("show");
    },
    mouseout() {
      // this.$refs.panelHeader.$refs.settingSection.$el.classList.remove("show");
    },

    async handleFilterChange() {
      // this.overviewData = null
      if((!this.loading && this.dataModel.dateEnd) ||this.dataModel.dateEnd) {
        this.loading = true;
        this.tableData.data = []
        this.rawData = await this.fetchIntentToIntents(this.controller.selection);
        if(this.$el.querySelector(".el-loading-mask")) {
          this.$el.querySelector(".el-loading-mask").style.display = 'none'
        }
        this.loading = false;
        if(this.rawData) {
          let tableData = WyPerformanceUtils.getTableData()
          if(this.controller.selection == 'all') {
            tableData.tableDataAllIntents.data = [];
            tableData.tableDataAllIntents.label = null;
            this.rawData.forEach((intentData, index) => {
              tableData.tableDataAllIntents.data[index] = intentData;
            });
            this.tableData = tableData.tableDataAllIntents;
          }
          if(this.controller.selection == 'contained') {
            tableData.tableDataIntentsContained.data = [];
            tableData.tableDataIntentsContained.label = null;
            this.rawData.forEach((intentData, index) => {
              tableData.tableDataIntentsContained.data[index] = intentData;
            });
            this.tableData = tableData.tableDataIntentsContained;
          }
          if(this.controller.selection == 'handoff') {
            tableData.tableDataIntentsHandedOff.data = [];
            tableData.tableDataIntentsHandedOff.label = null;
            this.rawData.forEach((intentData, index) => {
              tableData.tableDataIntentsHandedOff.data[index] = intentData;
            });
            this.tableData = tableData.tableDataIntentsHandedOff;
          }
          
          // setTimeout(()=>{
          //   this.loading = false;
          // }, 300)
        }
        else {
          this.tableData = {};
          this.loading = false;
        }
        // this.loading = false;
      }
    }
  },
  
  async created() {
    await this.handleFilterChange();
    // this.$el.classList.add("full-size");
  }
});
</script>

<style lang="scss">

//tables
.wy-performance-overview-panel-top-intents {
  // min-height: calc(100% - 20px);
  padding-right: 0px;
  // min-width: 641px !important;
  margin-bottom: 0px;
  border: 1px solid #CAD2DA;
  width: 50%;
  border-radius: 5px;
  margin-top: 20px;
  margin-right: 1vw;
  .el-loading-mask {
    height: 100px !important;
  }

  .table-flex-container{
    display: flex;
    justify-content: space-between;
  }
  .performance-table-head{
    font-family: Helvetica Neue, Arial, Helvetica, sans-serif !important;
    font-size: 14.5px !important;
    font-weight: 700 !important;
    color: var(--site-font-secondary-color) !important;
  }
  .head-container{
    border-bottom: 1px solid #CAD2DA;
    white-space: nowrap;
  }
  .total-valume-header {
    margin-right: 10px;
  }
  .percentage{
    position: relative;
    left: 0.5vw;
    width: 40px;
    text-align: right;
  }

  .intent{
    width: 22.34vw !important;
    max-width: 305px;
    display: inline-block;
    white-space: nowrap;
    overflow: hidden;
    /* margin-right: -18px; */
    text-overflow: ellipsis;
    position: relative;
  }

  thead {
    display: table;
    width: calc(100% - 0px);
    color: #000000;
    font-size: 14.5px;
    font-family: Helvetica Neue, Helvetica;
    font-weight: 500;
  }
  tbody {
    display: inline-block; /* to enable vertical scrolling */
    max-height: 570px; 
    overflow-y: scroll; /* keeps the scrollbar even if it doesn't need it; display purpose */
    width: calc(100% - 1px);
    padding-left: 1px;
    background-color: #FFF;
  }
  progress {
    display: block;
    width: 100%;
    padding: 0px 0 0 0;
    margin: 0;
    background: none;
    border: 0;
    border-radius:5 0px;
    text-align: left;
    position: relative;
    font-family: "Helvetica Neue", Helvetica;
    font-size: 15px;
  }
  progress.percentage-bar::-webkit-progress-value {
    background: #4D50E8 !important;
  }
  progress::-webkit-progress-bar {
    height: 12px;
    width: 80%;
    margin: 0 auto;
    background-color: #CAD2DA;
    border-radius: 100px; 
    position: relative;
    top:2px;
  }
  progress::-webkit-progress-value {
    display: inline-block;
    height: 11px;
    margin: 0px -10px 2px 0;
    // padding-left: 50px; /* Rounded corners requires a padding */
    border-radius: 50px 0 0 50px;
  }

  .intent-name{
    padding-left:31px;
    padding-right: 37px;
    font-family: Helvetica Neue, arial;
    color: var(--site-font-tertiary-color);
    font-size: 14.22px;
  }
  .index{
    width: 0vw;
    right: 31px;
    padding-right: 0.8vw;
    position: relative;
    font-family: Helvetica Neue, arial;
    color: var(--site-font-tertiary-color);
    font-size: 14.22px;
    padding-left: 0vw;
    font-weight: 500;
  }
  .table-head.intent-name {
    position: relative;
    left: 35px;
  }
  .volume{
    width: 4.24vw;
    position: relative;
    font-family: Helvetica Neue, arial;
    color: var(--site-font-tertiary-color);
    font-size: 14.22px;
    right: 7.5vw;
    text-align: center;
  }
  
  .total-volume{
    width: 1.82vw;
    position: relative;
    right: 10.23vw;
    padding-right: 0vw;
    font-family: Helvetica Neue, arial;
    color: var(--site-font-tertiary-color);
    font-size: 14.22px;
  }
  .flex-stats{
    display: flex;
    justify-content: space-around; 
    align-items: center;
    width: 11.7vw !important;
  }
  .performance-overview-table{
    width: 100%;
    height: 100%;
    border-collapse: collapse;
    font-size: 14.22px;
  }

  td {
    padding: 19px 15px;
  }

  .table-titles{
    .total-volume{
      position: relative !important;
      right: 7vw;
    }
  }

  tr {
    display: table; /* display purpose; th's border */
    width: 100%;
    box-sizing: border-box; /* because of the border (Chrome needs this line, but not FF) */
  }

  td {
    text-align: left;
    color: #000000;
    border-bottom: none;
    border-left: none;
    // width: 19px !important;
    font-size: 14.22px;
    font-family: Helvetica Neue, Helvetica;
    font-weight: 400;
  }
  .warning-row{
    color:black;
  }
  td.intent-name {
    width: 13.34vw !important;
    max-width: 267px;
    display: inline-block;
    white-space: nowrap;
    overflow: hidden;
    margin-right: 0px;
    text-overflow: ellipsis;
    position: relative;
    left: 20px;
    display: flex;
  }
  .change-overtime-info{
    display: flex;
    flex-direction: column;
    margin-left: 0.3vw;
  }
  .top-flex{
    background-color: #FFF;
  }
  .el-table .cell {
    font-size: 14.22px;
    color: var(--site-font-chart-color);
    font-weight: normal;
    position: relative;
    left: 0.35vw;
  }

  .icon-info{
    display: inline-block;
    background: url('../../../assets/icons/icon_info_performance_overview.svg') no-repeat;
    width: 20px;
    height: 17px;
    position: relative;
    top: 8px;
    margin-left: 0.25vw;
  }
  #line-chart{
    position: relative;
    right: 1vw;
    width: 22.59vw;
    bottom: 2vw;
  }
  .move-info{
    width: 0.9vw;
    height: 19px;
    margin-left: 5px;
    position: relative;
    top: 4px;
  }
}

.wy-performance-overview-panel-top-intents {
  .no-data-flex{
    display: flex;
    min-height: 583px;
    flex-direction: column;
    align-items: flex-start;
  }
  .no-data-image{
    margin-top: 25% !important;
    margin-left: 39.5%;
    width: 21%;
  }
  .panel-top-title{
    font-family: Helvetica Neue, Arial, Helvetica, sans-serif;
    padding: 15px 15px 0 15px;
    font-size: 14.5px;
    font-weight: medium;
    color: var(--site-font-secondary-color);
  }
  .no-data-text{
    font-family: Helvetica Neue, Arial, Helvetica, sans-serif;
    font-size: 1.05vw;
    color: var(--site-font-tertiary-color);
    font-weight: 500;
    margin-left: 0.2vw;
    width: 100%;
    text-align: center;
    margin-top: 1.46vw;
  }
  .no-data-text-small{
    font-family: Helvetica Neue, Arial, Helvetica, sans-serif;
    font-size: 14.5px;
    color: var(--site-font-tertiary-color);
    margin-top: 1.17vw;
    margin-left: 0.2vw;
    margin-bottom: 3.27vw;
    width: 100%;
    text-align: center;
  }
}
.wy-performance-overview-panel-top-intents.full-size {
  height: 100% !important;
  // .el-loading-mask {
  //   top: 66px;
  //   height: calc(100% - 64px) !important;
  // }
}
.wy-performance-overview-page .wy-performance-overview-panel-top-intents.panel-component-section {
  .el-loading-mask {
    top: 0 !important;
  }
}
</style>